import { render, staticRenderFns } from "./TaskOk.vue?vue&type=template&id=4574c231&scoped=true"
import script from "./TaskOk.vue?vue&type=script&lang=js"
export * from "./TaskOk.vue?vue&type=script&lang=js"
import style0 from "./TaskOk.vue?vue&type=style&index=0&id=4574c231&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4574c231",
  null
  
)

export default component.exports